export default {
    // A
    addPhoto: 'Add photo',

    // B
    backgroundColor: 'Background color',

    // C
    chooseBackgroundColor: 'Choose a background color',
    createGroup: 'Create group',

    // R
    replacePhoto: 'Replace photo',
}
